<template>
    <div v-if="showBar" class="team-portal-bar">
        <div class="team-portal-bar-content">
            <span class="team-portal-bar-text">
                The new Team Portal is here — a faster, modern experience for managing your team.
            </span>
            <a :href="teamPortalUrl" class="team-portal-bar-link" target="_blank" rel="noopener">
                Switch to Team Portal
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <path d="M7 17L17 7" />
                    <path d="M7 7h10v10" />
                </svg>
            </a>
        </div>
        <button class="team-portal-bar-dismiss" @click="dismiss" aria-label="Dismiss">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { FEATURE_NAMES } from '@/utils/constants';

const STORAGE_KEY = 'teamPortalPromotionDismissed';

export default {
    name: 'TeamPortalPromotion',
    data() {
        return {
            showBar: false
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            isCustomer: 'user/isCustomer',
            isCustomerAdmin: 'user/isCustomerAdmin'
        }),
        teamPortalUrl() {
            return process.env.VUE_APP_TEAM_PORTAL_URL || '';
        },
        hasFeatureToggle() {
            const enabledFeatures = this.user.features;
            if (!enabledFeatures || !enabledFeatures.length) {
                return false;
            }
            return enabledFeatures.includes(FEATURE_NAMES.TeamPortalPromotion);
        },
        isExcludedRole() {
            return this.isCustomer || this.isCustomerAdmin;
        }
    },
    mounted() {
        this.evaluateVisibility();
    },
    methods: {
        evaluateVisibility() {
            if (this.isExcludedRole) {
                return;
            }

            if (!this.hasFeatureToggle) {
                return;
            }

            if (!this.teamPortalUrl) {
                return;
            }

            if (sessionStorage.getItem(STORAGE_KEY)) {
                return;
            }

            this.showBar = true;
        },
        dismiss() {
            this.showBar = false;
            sessionStorage.setItem(STORAGE_KEY, 'true');
        }
    }
};
</script>

<style scoped>
.team-portal-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #2B93FF;
    color: #fff;
    padding: 8px 16px;
    font-size: 13px;
    width: 100%;
    z-index: 999;
    animation: team-portal-bar-slideDown 0.3s ease-out;
}

.team-portal-bar-content {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.team-portal-bar-badge {
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    flex-shrink: 0;
}

.team-portal-bar-text {
    color: rgba(255, 255, 255, 0.9);
}

.team-portal-bar-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #fff !important;
    font-weight: 600;
    text-decoration: none !important;
    background: rgba(255, 255, 255, 0.15);
    padding: 4px 12px;
    border-radius: 6px;
    transition: background 0.15s;
    white-space: nowrap;
    flex-shrink: 0;
}

.team-portal-bar-link:hover {
    background: rgba(255, 255, 255, 0.25);
    color: #fff !important;
    text-decoration: none !important;
}

.team-portal-bar-dismiss {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: color 0.15s, background 0.15s;
}

.team-portal-bar-dismiss:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.15);
}

@keyframes team-portal-bar-slideDown {
    from {
        opacity: 0;
        transform: translateY(-100%);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
